import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "./api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking
  const [ready, setReady] = useState(false);
  const [features, setFeatures] = useState({ forecasting: true }); // default all on until fetched

  const fetchFeatures = useCallback(async () => {
    try {
      const { data } = await api.get("/features");
      setFeatures(data);
    } catch (_) {
      // keep defaults
    }
  }, []);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch (_) {
      setUser(false);
    } finally {
      setReady(true);
    }
  }, []);

  useEffect(() => {
    fetchFeatures();
    refresh();
  }, [refresh, fetchFeatures]);

  const login = async ({ email, password, captcha_id, captcha_answer }) => {
    const { data } = await api.post("/auth/login", {
      email, password, captcha_id, captcha_answer,
    });
    if (data?.access_token) localStorage.setItem("kedan_token", data.access_token);
    setUser(data.user);
    await fetchFeatures(); // refresh features on login
    return data.user;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (_) {}
    localStorage.removeItem("kedan_token");
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, ready, login, logout, refresh, setUser, features }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
